import {getEntity} from "../entity/entity-service";

import {getPlayer as _getPlayer} from "../../modules/player";

export const getActiveGameSessionId = (player) => {
    // active game session or most recently created assigned game session
    if (typeof player.active_game_session === "object") {
      return player.active_game_session.id
    }
    
    return player.active_game_session || (
        player.game_sessions &&
        player.game_sessions.reduce((previousValue, currentValue) => {
            return previousValue < currentValue ? currentValue : previousValue
        }, 0)
    );
};


export async function getPlayer(playerId, props) {
    return await getEntity(props.dispatch, _getPlayer(playerId));
}



// WEBPACK FOOTER //
// ./src/services/player/player-service.js